


























import Vue from 'vue';
import { mapActions, mapState } from 'vuex';
import List from '@/components/Common/List.vue';
import TextCard from '@/components/TextList/TextCard.vue';
import TextInput from '@/components/TextList/TextInput.vue';

export default Vue.extend({
  name: 'TextList',
  components: {
    List,
    TextCard,
    TextInput,
  },
  props: {},
  data() {
    return {
      textsPerLine: 4,
      isComponentModalActive: false,
    };
  },
  computed: mapState('text', ['texts']),
  methods: mapActions('text', ['loadTexts', 'clearText']),
  mounted() {
    this.loadTexts();
    this.clearText();
  },
});
